import { animate, AUTO_STYLE, style, transition, trigger } from '@angular/animations';

export const ExpandLeft = trigger(
	'expandLeft', [
		transition(':enter', [
			style({ width: 0 }),
			animate('175ms ease-out', style({ width: AUTO_STYLE })),
		]),
		transition(':leave', [
			animate('225ms ease-in', style({ width: 0 })),
		]),
	]
)